<template>
  <div class="w-100">
<!--    <transition name="fade-prompt">
      <div v-if="susccesShow" class="position-absolute" style="left: 820px;z-index: 10">
        <div class="prompt-success d-flex align-content-center shadow-lg" >
          <b-icon icon="check" font-scale="2" style="background: rgb(19,206,102);color: white"></b-icon>
          <div class="text-black-50 font-weight-bold prompt-success-text d-flex align-items-center justify-content-center">
            Added successfully
          </div>
        </div>
      </div>
    </transition>-->
    <success ref="mySuccess"></success>


    <div class="container-box mx-auto">
      <!-- 商品主体部分 -->
      <div class="d-flex pb-5">
        <div class="pro-body d-flex justify-content-between">
          <div style="width: 200px;height: 200px" class="border">
<!--            <pic-zoom  url="/imgs/product/img.png" :scale="3"></pic-zoom>-->
            <pic-zoom  :url="form.imgUrl" :scale="3"></pic-zoom>
          </div>
          <div class="pro-body-info">
            <h4 class="pro-info-title">{{form.name}}</h4>
            <hr>
            <div class="prod-detail">
              <div class="prod-detail-items">
                <label>Product Name</label>
                <span>{{ form.name}}</span>
              </div>
              <div class="prod-detail-items">
                <label>Manufacturer</label>
                <span>{{form.manufacturerName}}</span>
              </div>
              <div class="prod-detail-items">
                <label>Describe</label>
                <span>{{form.attributes.Describe}}</span>
              </div>
              <div class="prod-detail-items">
                <label>Classification</label>
                <span>{{form.attributes['Classification:']}}</span>
              </div>
              <div class="prod-detail-items">
                <label>Datesheet</label>
                <span style="width: 22em" class="box-overflow-hidden"><b-link v-if="!!form.attributes['Datesheet']" @click.prevent="getDateSheet">
                  {{(!!form.dateSheet?form.dateSheet:form.attributes['Datesheet']) | getLastElementFromUrl }}
                </b-link></span>
              </div>
              <div class="prod-detail-items">
                <label>Stock</label>
                <span>{{form.attributes['Stock']}}</span>
              </div>
              <div class="prod-detail-items d-flex">
                <label>Customer Reference</label>
                <b-input style="width: 80%" v-model="remark" ></b-input>
              </div>
              <div class="prod-detail-items d-flex">
                <label>{{form.attributes['Classification:']}}</label>
              </div>
            </div>
          </div>
        </div>
        <!--  加购按钮    -->
        <div class="rfq-box flex-grow-1">
          <div class="prod-detail-items">
            <!--  title  -->
            <h4>{{form.attributes['Stock']}} In Stock</h4>
          </div>
          <hr>
          <div class="prod-detail-items">
            <label>More quantities are on the way.</label>
          </div>
          <div class="prod-detail-items">
            <number-input v-model="rfqForm.num" value="1"></number-input>
          </div>
          <div class="prod-detail-items">
            <button style="background: rgb(232,133,67)" class="w-100 btn text-white font-weight-bold mb" @click="rfqBtn">RFQ</button>
          </div>
          <div class="prod-detail-items">
            <button style="background: rgb(31,47,100)" class="w-100 btn text-white font-weight-bold" @click="rfqBtnToList">Add To RFQ List</button>
          </div>
        </div>
      </div>

      <!--   Attributes   -->
      <div class="w-100 pb-5">
        <h4 class="pb-4 font-weight-bold">Product Attributes</h4>
        <!--    attr TABLE    -->
        <div class="attr-tab">
          <div class="a-tab-bg">
            <span class="attr-title">Type</span>
            <span class="attr-title">PARAMETERS</span>
          </div>
          <div :class="index % 2 === 0?'':'a-tab-bg'" v-for="(key,index) in Object.keys(form.spec)" :key="index">
            <span class="attr-title">{{ key }}</span>
            <span class="attr-param">{{ form.spec[key] }}</span>
          </div>
        </div>
      </div>

      <!--   Related Products   -->
      <div class="w-100 pb-5">
        <h4 class="pb-4 font-weight-bold">Related Products</h4>
        <div class="d-flex flex-wrap justify-content-between">
          <div class="mb-4 border d-flex p-4 justify-content-center align-items-center" v-for="(item,index) in 8" :key="index">
            <b-img src="/imgs/product/img.png" width="100"></b-img>
            <div>
              <b-link to="#" class="relate-link">FDC2212DNTR</b-link>
              <p>Texas Instruments</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PicZoom from "@comp/PicZoom.vue";
import numberInput from "@/components/NumberInput.vue";
import Success from "@comp/Success.vue";
import {getAction} from "@/api/manage";
export default {
  name: "productDetail",
  components:{
    Success,
    PicZoom,
    numberInput
  },
  data(){
    return{
      susccesShow:false,
      remark: '',
      form:{
        id:'',
        // spec:{'Number of Inputs': 'Up to 24', 'Base Product Number': 'AT42QT1244', 'Mfr': 'Microchip Technology', 'Current - Supply': '6.6mA', 'Package': 'Tape & Reel (TR)^^Cut Tape (CT)', 'Product Status': 'Active', 'Interface': 'I²C', 'Voltage - Supply': '3V ~ 5V', 'LED Driver Channels': '-', 'Resolution': '10 b', 'Operating Temperature': '-40°C ~ 105°C', 'Package / Case': '32-VFQFN Exposed Pad', 'Series': 'QMatrix™', 'Type': 'Buttons', 'Proximity Detection': 'No', 'Mounting Type': 'Surface Mount', 'Supplier Device Package': '32-VQFN (5x5)'},
        // attributes:{},
        // RelateProducts:[]
      },
      rfqForm:{
        num:1
      }
    }
  },
  filters:{
    getLastElementFromUrl(url){
      // 使用正则表达式检查是否包含http或https
      const regex = /(http|https):\/\//;
      if (regex.test(url)) {
        const parts = url.split('/');
        return parts[parts.length - 1];
      } else {
        return url;
      }
    }
  },
  async created() {
    await this.init();
    // console.log(Object.keys(this.form.attributes))
    // console.log(this.form.attributes)
  },
  mounted() {

  },
  computed:{

  },
  methods:{
    rfqBtn(){
      document.getElementsByClassName('woot-widget-bubble woot-elements--right')[0].click()
      this.rfqBtnToList()
      this.$router.push("/inquiry")
    },
    getDateSheet(){
      if(!!this.form.datasheet){
        window.open(this.form.datasheet, '_blank');
        return;
      }
      getAction("/front/product/getDateSheet/" + this.form.id, {}).then(res => {
        if(res.success){
          window.open(res.result, '_blank');
        }
      })
    },
    rfqBtnToList(){
      const {id,name,manufacturerName,manufacturerId }= this.form
      const pro = {id,partNumber:name,manufacturer:manufacturerName,manufacturerId,quantity:this.rfqForm.num,targetPrice:0.00,remark:this.remark};
      pro.describe = this.form.attributes["Describe"];
      this.$store.commit("addShopping",pro)

      this.$refs.mySuccess.success();
      // this.susccesShow = true
      // setTimeout(() => this.susccesShow = false,2000)
    },
    async init() {
      if (this.$route.params.id) {
        this.form.id = this.$route.params.id
      }
      await getAction("/front/product/getById/" + this.form.id, {}).then(res => {
        this.form = {...res.result}
        let seoTitle = res.result.seoTitle || res.result.name+' '+res.result.manufacturerName;
        let seoKeyword = res.result.seoKeyword || res.result.name+' '+res.result.manufacturerName
        let seoDesc = res.result.seoDesc || res.result.name+' '+res.result.manufacturerName+','+this.$store.getters.description
        /*if(!!res.result.seoKeyword){
          seoKeyword = res.result.seoKeyword;
        }else{
          seoKeyword = res.result.name+' '+res.result.manufacturerName;
        }
        if(!!res.result.seoDesc){
          seoDesc = res.result.seoDesc;
        }else{
          seoDesc = res.result.name+' '+res.result.manufacturerName+','+this.$store.getters.description;
        }*/
        this.$initMeta(seoTitle,seoKeyword,seoDesc)
      })
    }
  }
}
</script>

<style lang="scss">
.fade-prompt-enter-active, .fade-prompt-leave-active {
  transition: opacity .2s;
}
.fade-prompt-enter, .fade-prompt-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.prompt-success{
  border-radius: 5px;
  width: 300px;
  .prompt-success-text{
    width: 100%;
    //text-align: center;
  }
}
.pro-body{
  .pro-body-info{
    width: 700px;
    margin-left: 50px;
  }
}
.prod-detail{

}

.prod-detail-items{
  margin-bottom: 10px;

  label{
    font-size: 12px;
    font-family: Poppins-SemiBold;
    font-weight: 600;
    color: #000;
    line-height: 18px;
    min-width: 140px;
    margin: 0!important;
  }
  span{
    font-size: 12px;
    display: inline-block;
    font-family: Poppins-Medium;
    font-weight: 500;
    color: #4f5866;
    line-height: 18px;
  }
}

.rfq-box{
  padding-left: 54px;
}
.attr-tab{
  span{
    display: inline-block;
    width: 50%;
    padding: 10px 20px;
    font-size: 15px;
  }
  .a-tab-bg{
    background: #f1f4f8;
    border-top: 1px solid #ccced4;
    border-bottom: 1px solid #ccced4;
  }
  .attr-title{
    font-weight: bold;
    color: #242e3e;
    line-height: 26px;
  }
  .attr-param{
    color: #4F5866;
  }
}
.relate-link{
  font-weight: bold;
  color: black !important;
}
</style>